<template>
    <div class="start-screen">
        <img
            src="/apotheke_clean_02.png"
            alt="Apotheke"
            class="pharmacy-background"
        />

        <div class="start-card">
            <h1 class="greeting-title">Werde Sichtwahl Hero</h1>
            <p class="main-question">
                Ordne jeder Aussage das passende MEDICE-Produkt zu und ziehe dafür die Packung in den markierten
                Sichtwahlbereich.
            </p>

            <div class="circle-container">
                <img
                    src="/regal-ani.gif"
                    alt="Hand"
                    class="hand-pointer"
                />
            </div>

            <p class="instruction-text">Jedes richtige Match zählt!</p>
        </div>
        <button
            class="start-button"
            @click="emit('start')"
        >
            Spiel starten
        </button>
    </div>
</template>

<script setup lang="ts">
    const emit = defineEmits<{
        start: [];
    }>();
</script>

<style scoped lang="scss">
    .start-screen {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        box-sizing: border-box;
        flex-direction: column;
    }

    .start-screen .pharmacy-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        z-index: 1;
    }

    .start-screen .start-card {
        position: relative;
        z-index: 2;
        background: #309aad;
        border-radius: 30px;
        padding: 40px;
        box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
        border: 3px solid rgba(255, 255, 255, 0.3);
        text-align: center;
        max-width: 650px;
        width: 80%;
    }

    .start-screen .greeting-title {
        font-family: 'Montserrat', 'Arial', sans-serif;
        font-weight: 700;
        font-size: 26px;
        color: #ffffff;
        margin: 0 0 20px 0;
        text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
    }

    .start-screen .main-question {
        font-family: 'Montserrat', 'Arial', sans-serif;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        line-height: 1.4;
        margin: 0;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    }

    .start-screen .circle-container {
        position: relative;
        width: 140px;
        margin: 0 auto;
    }

    .start-screen .hand-pointer {
        position: relative;
        bottom: 0;
        width: 100%;
        height: auto;
        z-index: 3;
        margin-left: 20px;
    }

    .start-screen .instruction-text {
        position: relative;
        z-index: 3;
        font-family: 'Montserrat', 'Arial', sans-serif;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
        line-height: 1.5;
        margin: 0 0 0;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    }

    .start-screen .start-button {
        font-family: 'Montserrat', 'Arial', sans-serif;
        font-weight: 700;
        font-size: 23px;
        color: #ffffff;
        background: linear-gradient(260deg, #b81580 0%, rgba(184, 21, 128, 0) 100%);
        border: none;
        border-radius: 50%;
        padding: 0;
        cursor: pointer;
        transition: all 0.3s ease;
        height: 130px;
        width: 130px;
        text-align: center;
        flex-shrink: 0;
        z-index: 9;
        margin-top: 10px;
    }

    .start-screen .start-button:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(245, 166, 35, 0.5);
        background: linear-gradient(135deg, #f7b13d 0%, #f5a623 100%);
    }

    .start-screen .start-button:active {
        transform: translateY(0);
        box-shadow: 0 3px 10px rgba(245, 166, 35, 0.4);
    }

    .start-screen .start-button:focus-visible {
        outline: 3px solid currentColor;
        outline-offset: 4px;
    }
</style>
